import { type ReactNode } from 'react';

export enum StickyBannerPlacement {
  left = 'left',
  right = 'right',
}

export interface StickyBannerProps {
  content: ReactNode;

  background?: string;
  placement?: StickyBannerPlacement;

  defaultPosition?: number;

  onClick?: () => void;
}

export interface StickyBannerState {
  banners: Record<
    string,
    | { isOpen: boolean; isCollapsed: boolean; offset: number; props: StickyBannerProps }
    | undefined
  >;
}

export interface StickyBannerStore extends StickyBannerState {
  actions: {
    open: (key: string, props: StickyBannerProps) => void;
    close: (key: string) => void;
    toggleCollapse: (key: string) => void;
    updateProps: (key: string, props: Partial<StickyBannerProps>) => void;
  };
}
